import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70bf091c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=70bf091c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf091c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bf091c')) {
      api.createRecord('70bf091c', component.options)
    } else {
      api.reload('70bf091c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70bf091c&scoped=true", function () {
      api.rerender('70bf091c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/index.vue"
export default component.exports